import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from './header';
import Body from './body';
import Menu from './menu';
import ManagerLink from '../windowsManager/managerLink';

function LayoutGrid() {
  const [menuExpanded, setMenuExpanded] = useState(true);
  return (
    <Box>
      <Header menuExpanded={menuExpanded} />
      <Menu
        menuExpanded={menuExpanded}
        onToggleMenuExpaned={() => setMenuExpanded((o) => !o)}
      />
      <Body menuExpanded={menuExpanded} />
      <ManagerLink menuExpanded={menuExpanded} />
    </Box>
  );
}

export default LayoutGrid;
